import { Component, OnInit } from '@angular/core';
import { ZpDataService } from '../services/zp-data.service';
import { SideNavBarVisibilityService } from '../services/side-nav-bar-visibility.service';
import { ThemeService } from '../theme/theme-service.service';

@Component({
    selector: 'app-my-delegates',
    templateUrl: './my-delegates.component.html',
    styleUrls: ['./my-delegates.component.scss'],
    standalone: false
})
export class MyDelegatesComponent implements OnInit {

  constructor(private api: ZpDataService, public sideNavBarVisibilityService: SideNavBarVisibilityService, public themeService: ThemeService) { }

  ngOnInit() {

  }

}
